import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RightPanel from '@/components/RightPanel';
import { AppMain, Navbar, Settings, Sidebar, TagsView, CallDrawer } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from 'vuex';
export default {
  name: 'Layout',
  components: {
    AppMain: AppMain,
    Navbar: Navbar,
    RightPanel: RightPanel,
    Settings: Settings,
    Sidebar: Sidebar,
    TagsView: TagsView,
    CallDrawer: CallDrawer
  },
  mixins: [ResizeMixin],
  computed: _objectSpread(_objectSpread({}, mapState({
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    showSettings: function showSettings(state) {
      return state.settings.showSettings;
    },
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    },
    fixedHeader: function fixedHeader(state) {
      return state.settings.fixedHeader;
    },
    drawerState: function drawerState(state) {
      return state.drawer.drawerState;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    }
  }),
  watch: {
    'sidebar.opened': function sidebarOpened(val) {
      var drawerState = this.drawerState;
      if (val && drawerState) {
        this.asideWidth = '470px';
      }
      if (val && !drawerState) {
        this.asideWidth = '200px';
      }
      if (!val && drawerState) {
        this.asideWidth = '334px';
      }
      if (!val && !drawerState) {
        this.asideWidth = '64px';
      }
    },
    drawerState: function drawerState(val) {
      var opened = this.sidebar.opened;
      if (val && opened) {
        this.asideWidth = '470px';
      }
      if (val && !opened) {
        this.asideWidth = '334px';
      }
      if (!val && opened) {
        this.asideWidth = '200px';
      }
      if (!val && !opened) {
        this.asideWidth = '64px';
      }
    }
  },
  data: function data() {
    return {
      refreshLostIntervalId: null,
      activeName: 'revenue',
      callStyle: {
        height: 0 + 'px'
      },
      callDrawerState: true,
      asideWidth: '200px'
      // styleWidth: this.sidebar.opened
    };
  },
  mounted: function mounted() {
    var opened = this.sidebar.opened;
    if (opened) {
      this.asideWidth = '200px';
    } else {
      this.asideWidth = '64px';
    }
    // const appWrapper = this.$refs.appWrapper
    // console.log(appWrapper)
    // const _this = this
    // this.refreshLostIntervalId = setInterval(() => {
    //   console.log('lost/loadStatistics')
    //   _this.$store.dispatch('lost/loadStatistics').then(res => {
    //     console.log('lost/loadStatistics', res)
    //   })
    // }, 30000)
  },
  destroyed: function destroyed() {
    if (this.refreshLostIntervalId) {
      clearInterval(this.refreshLostIntervalId);
    }
  },
  methods: {
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    },
    /**
     * 关闭
     */
    shutDown: function shutDown() {
      this.$store.commit('drawer/DRAWER_STATE', false);
    }
  }
};